import { Button, ModalV2 as Modal } from '@utilities';

export interface DeleteProjectModalProps {
  handleDeleteProject: ({ projectSessionId }: { name: string; projectSessionId: string }) => void;
  isModalActive: boolean;
  narrativeCount: number;
  projectName: string;
  projectSessionId: string;
  setIsModalActive: (isActive: boolean) => void;
}

const DeleteProjectModal = ({
  handleDeleteProject,
  isModalActive,
  narrativeCount,
  projectName,
  projectSessionId,
  setIsModalActive,
}: DeleteProjectModalProps) => {
  return (
    <Modal
      buttons={[
        <Button
          key="cancel-btn"
          onClick={() => setIsModalActive(false)}
          text="Cancel"
          variant="secondary"
        />,
        <Button
          key="delete-btn"
          onClick={() => {
            setIsModalActive(false);
            handleDeleteProject({ name: projectName, projectSessionId: projectSessionId });
          }}
          text="Delete"
          variant="error"
        />,
      ]}
      isActive={isModalActive}
      onClose={() => setIsModalActive(false)}
      title="Delete"
    >
      <p>
        This will permanently delete “{projectName}” and the {narrativeCount} narrative(s) in this
        project. This action cannot be undone.
      </p>
    </Modal>
  );
};

export default DeleteProjectModal;
